import { Controller } from "@hotwired/stimulus"

// Shows the fields that only apply to a supplementary notice, or to a taxpayer
// without a DIČ. All validation and XML generation happens on the server.
export default class extends Controller {
  static targets = ["supplementaryCheckbox", "supplementaryFields", "withoutTaxIdCheckbox", "withoutTaxIdFields"]

  connect() {
    this.toggleSupplementary()
    this.toggleTaxIdFields()
  }

  toggleSupplementary() {
    if (!this.hasSupplementaryCheckboxTarget || !this.hasSupplementaryFieldsTarget) return

    this.supplementaryFieldsTarget.classList.toggle("d-none", !this.supplementaryCheckboxTarget.checked)
  }

  toggleTaxIdFields() {
    if (!this.hasWithoutTaxIdCheckboxTarget || !this.hasWithoutTaxIdFieldsTarget) return

    this.withoutTaxIdFieldsTarget.classList.toggle("d-none", !this.withoutTaxIdCheckboxTarget.checked)
  }
}
